import { render, staticRenderFns } from "./RowHeaders.vue?vue&type=template&id=ebc81ea2&scoped=true"
import script from "./RowHeaders.vue?vue&type=script&lang=js"
export * from "./RowHeaders.vue?vue&type=script&lang=js"
import style0 from "./RowHeaders.vue?vue&type=style&index=0&id=ebc81ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc81ea2",
  null
  
)

export default component.exports